<script setup>
defineProps({
  featureKey: { type: String, required: true },
});

const FEATURE_CONFIG = {
  crm: {
    icon: 'i-lucide-layout-panel-left',
    gradient: 'from-blue-600/20 to-cyan-600/20',
    iconColor: 'text-blue-400',
    btnGradient: 'from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700',
    btnShadow: 'hover:shadow-blue-500/25',
    title: 'CRM / Kanban não está no seu plano',
    description:
      'Organize seus leads em pipelines visuais, acompanhe negociações e aumente suas conversões com um CRM integrado ao WhatsApp.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20saber%20mais%20sobre%20o%20m%C3%B3dulo%20CRM%2FKanban.',
  },
  agenda: {
    icon: 'i-lucide-calendar-range',
    gradient: 'from-emerald-600/20 to-teal-600/20',
    iconColor: 'text-emerald-400',
    btnGradient: 'from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700',
    btnShadow: 'hover:shadow-emerald-500/25',
    title: 'Agenda não está no seu plano',
    description:
      'Gerencie agendamentos, horários e recursos diretamente pelo SIC. Seus clientes agendam pelo WhatsApp e você controla tudo em um só lugar.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20saber%20mais%20sobre%20o%20m%C3%B3dulo%20Agenda.',
  },
  conversions: {
    icon: 'i-lucide-trending-up',
    gradient: 'from-orange-600/20 to-amber-600/20',
    iconColor: 'text-orange-400',
    btnGradient: 'from-orange-600 to-amber-600 hover:from-orange-700 hover:to-amber-700',
    btnShadow: 'hover:shadow-orange-500/25',
    title: 'Conversões não está no seu plano',
    description:
      'Rastreie e analise todas as conversões de leads em clientes. Entenda de onde vêm seus resultados e otimize seu funil de vendas.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20saber%20mais%20sobre%20o%20m%C3%B3dulo%20Convers%C3%B5es.',
  },
  master_ai: {
    icon: 'i-lucide-brain-circuit',
    gradient: 'from-violet-600/20 to-indigo-600/20',
    iconColor: 'text-indigo-400',
    btnGradient: 'from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700',
    btnShadow: 'hover:shadow-indigo-500/25',
    title: 'IA Mestre não está no seu plano',
    description:
      'Crie agentes de IA que analisam, respondem e automatizam absolutamente tudo no seu SIC. Upgrade e coloque sua operação no piloto automático.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20IA%20Mestre.',
  },
  ia_comercial: {
    icon: 'i-lucide-bot',
    gradient: 'from-emerald-600/20 to-teal-600/20',
    iconColor: 'text-emerald-500',
    btnGradient: 'from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700',
    btnShadow: 'hover:shadow-emerald-500/25',
    title: 'IA Comercial não está no seu plano',
    description:
      'Agentes de vendas automatizados que respondem leads no WhatsApp 24h por dia, qualificam contatos e agendam reuniões — no piloto automático.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20IA%20Comercial%20(Agentes%20de%20Vendas%20Automatizados).',
  },
  ia_entrevista: {
    icon: 'i-lucide-clipboard-list',
    gradient: 'from-indigo-600/20 to-violet-600/20',
    iconColor: 'text-indigo-500',
    btnGradient: 'from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700',
    btnShadow: 'hover:shadow-indigo-500/25',
    title: 'IA Entrevista nao esta no seu plano',
    description:
      'Agentes de IA para entrevistas tecnicas personalizadas de onboarding. Automatize a coleta de informacoes de novos clientes com follow-ups inteligentes.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20IA%20Entrevista.',
  },
  super_funcionarios: {
    icon: 'i-lucide-sparkles',
    gradient: 'from-violet-600/20 to-purple-600/20',
    iconColor: 'text-violet-500',
    btnGradient: 'from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700',
    btnShadow: 'hover:shadow-violet-500/25',
    title: 'IA Super Funcionários não está no seu plano',
    description:
      'Crie agentes de IA avançados com base em documentação completa de projeto. Automatize processos internos complexos com inteligência.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20IA%20Super%20Funcion%C3%A1rios.',
  },
  social_hub: {
    icon: 'i-lucide-film',
    gradient: 'from-violet-600/20 to-pink-600/20',
    iconColor: 'text-violet-400',
    btnGradient: 'from-violet-600 to-pink-600 hover:from-violet-700 hover:to-pink-700',
    btnShadow: 'hover:shadow-violet-500/25',
    title: 'Social Hub não está no seu plano',
    description:
      'Crie Reels e vídeos virais com IA. Transcrição automática, cortes inteligentes com metodologia viral e legendas incluídas.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20Social%20Hub.',
  },
  video_studio_trial: {
    icon: 'i-lucide-flask-conical',
    gradient: 'from-violet-600/20 to-purple-600/20',
    iconColor: 'text-violet-400',
    btnGradient: 'from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700',
    btnShadow: 'hover:shadow-violet-500/25',
    title: 'Sky Video Studio AI — Experimente Grátis',
    description:
      'Teste gratuitamente com 2 vídeos. Análise por IA, cortes automáticos e legendas profissionais. Acesso exclusivo por aprovação.',
    whatsapp:
      'Ol%C3%A1!%20Quero%20experimentar%20o%20Sky%20Video%20Studio%20AI.',
    ctaUrl: '/studio/trial',
    ctaLabel: 'Solicitar acesso TRIAL',
  },
  video_studio_basic: {
    icon: 'i-lucide-video',
    gradient: 'from-blue-600/20 to-cyan-600/20',
    iconColor: 'text-blue-400',
    btnGradient: 'from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700',
    btnShadow: 'hover:shadow-blue-500/25',
    title: 'Upgrade para Video Studio BASIC',
    description:
      '3 vídeos editados por semana. Corte de silêncio, Smart Cut IA e legendas automáticas. Reinicia toda segunda-feira.',
    whatsapp:
      'Ol%C3%A1!%20Quero%20contratar%20o%20Sky%20Video%20Studio%20BASIC.',
  },
  video_studio_ilimitado: {
    icon: 'i-lucide-crown',
    gradient: 'from-amber-600/20 to-orange-600/20',
    iconColor: 'text-amber-400',
    btnGradient: 'from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700',
    btnShadow: 'hover:shadow-amber-500/25',
    title: 'Upgrade para Video Studio ILIMITADO',
    description:
      'Produza vídeos sem limite com suas próprias chaves de API. OpenAI + Gemini configuráveis. Para criadores de conteúdo profissionais.',
    whatsapp:
      'Ol%C3%A1!%20Quero%20contratar%20o%20Sky%20Video%20Studio%20ILIMITADO.',
  },
  commission_management: {
    icon: 'i-lucide-percent',
    gradient: 'from-sky-600/20 to-blue-600/20',
    iconColor: 'text-sky-400',
    btnGradient: 'from-sky-600 to-blue-600 hover:from-sky-700 hover:to-blue-700',
    btnShadow: 'hover:shadow-sky-500/25',
    title: 'Módulo de Comissões não está habilitado',
    description:
      'Gerencie o comissionamento de consultores com fechamento mensal automático, auditoria completa e integração com o CRM.',
    whatsapp:
      'Ol%C3%A1%2C%20Bruno!%20J%C3%A1%20sou%20cliente%20do%20SIC%20e%20quero%20saber%20mais%20sobre%20o%20m%C3%B3dulo%20de%20Comiss%C3%B5es.',
  },
};
</script>

<template>
  <div class="flex h-full items-center justify-center bg-n-background px-6">
    <div class="max-w-md w-full text-center">
      <div
        :class="[
          'flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br mx-auto mb-6',
          FEATURE_CONFIG[featureKey]?.gradient,
        ]"
      >
        <span
          :class="[
            'text-4xl',
            FEATURE_CONFIG[featureKey]?.icon,
            FEATURE_CONFIG[featureKey]?.iconColor,
          ]"
        />
      </div>
      <h2 class="text-xl font-bold text-n-slate-12 mb-4 leading-snug">
        {{ FEATURE_CONFIG[featureKey]?.title }}
      </h2>
      <p class="text-sm text-n-slate-11 leading-relaxed mb-8">
        {{ FEATURE_CONFIG[featureKey]?.description }}
      </p>
      <div class="flex flex-col items-center gap-3">
        <a
          v-if="FEATURE_CONFIG[featureKey]?.ctaUrl"
          :href="FEATURE_CONFIG[featureKey].ctaUrl"
          target="_blank"
          :class="[
            'inline-flex items-center gap-2 bg-gradient-to-r text-white font-semibold px-6 py-3 rounded-xl transition-all shadow-lg hover:-translate-y-0.5',
            FEATURE_CONFIG[featureKey]?.btnGradient,
            FEATURE_CONFIG[featureKey]?.btnShadow,
          ]"
        >
          <span class="i-lucide-arrow-right text-lg" />
          {{ FEATURE_CONFIG[featureKey]?.ctaLabel || 'Saiba mais' }}
        </a>
        <a
          :href="`https://wa.me/5562982186318?text=${FEATURE_CONFIG[featureKey]?.whatsapp}`"
          target="_blank"
          :class="[
            'inline-flex items-center gap-2 bg-gradient-to-r text-white font-semibold px-6 py-3 rounded-xl transition-all shadow-lg hover:-translate-y-0.5',
            FEATURE_CONFIG[featureKey]?.btnGradient,
            FEATURE_CONFIG[featureKey]?.btnShadow,
          ]"
        >
          <span class="i-lucide-message-circle text-lg" />
          Falar com a equipe
        </a>
      </div>
    </div>
  </div>
</template>
